export const PREP_SERVICES_HELP_LINK =
  "https://support.portal.flexport.com/hc/en-us/categories/4478542544535-Prep-Services";

export const PREP_PRICING_AND_BILLING_HELP_LINK =
  "https://support.portal.flexport.com/hc/en-us/articles/14071464702103-Prep-Pricing-and-Billing";
